import raceTracking from '../../../../../../src24/js/modules/race/raceTracking';

window.addEventListener('load', () => {
    raceTracking.init();
});
